import React from 'react'
import { connect } from 'react-redux'

import AppLayout from '../App'
import SideMenu from '../_components/SideMenu'

const AccountLayout = ({ history, children, alert }) => {
  if (alert.message) {
    window.scroll(0,0)
  }

  return <AppLayout>
    <div className='container-fluid mt-4'>
      <div className="row">
        <SideMenu history={history}/>

        <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-md-4">
          { alert.message &&
            <div className={`alert ${alert.type}`}>{alert.message}</div>
          }
          
          { children }
        </main>
      </div>
    </div>
  </AppLayout>
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
}

export default connect(mapStateToProps)(AccountLayout);